import { render, staticRenderFns } from "./PromotionalOffersComponent.vue?vue&type=template&id=0153c57c"
import script from "./PromotionalOffersComponent.vue?vue&type=script&lang=js"
export * from "./PromotionalOffersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports